import { useState } from 'react';
import { X } from 'lucide-react';
import { SearchableSelect } from '../common/SearchableSelect';

interface EventSelectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (eventId: string) => void;
  title?: string;
}

export function EventSelectorModal({
  isOpen,
  onClose,
  onSelect,
  title = 'Select Event',
}: EventSelectorModalProps) {
  const [selectedEventId, setSelectedEventId] = useState<string>('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (selectedEventId) {
      onSelect(selectedEventId);
      setSelectedEventId('');
    }
  };

  const handleClose = () => {
    setSelectedEventId('');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={handleClose} />
      <div className="relative bg-white rounded-lg shadow-xl p-6 w-full max-w-md z-10">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Event</label>
          <SearchableSelect
            entityType="event"
            value={selectedEventId}
            onChange={(v) => setSelectedEventId(typeof v === 'string' ? v : '')}
            placeholder="Search events..."
          />
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={handleClose}
            className="px-4 py-2 border border-gray-300 text-gray-700 text-sm rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={!selectedEventId}
            className="px-4 py-2 bg-primary-600 text-white text-sm rounded-md hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
